export default __webpack_public_path__ + "static/media/doctor-media.45376a33.mp4";